document.addEventListener('DOMContentLoaded', function () {
  const accordions = document.querySelectorAll('.accordion-toggle');

  if (accordions.length > 0) {
    accordions.forEach(button => {
      button.addEventListener('click', function () {
        const section = button.parentElement;
        const isOpen = section.classList.contains('open');

        document.querySelectorAll('.accordion-section').forEach(s => s.classList.remove('open'));
        if (!isOpen) section.classList.add('open');
      });
    });
  }
});